import { render, staticRenderFns } from "./ActiveChecksDashboardPage.vue?vue&type=template&id=3c29f924"
import script from "./ActiveChecksDashboardPage.vue?vue&type=script&lang=js"
export * from "./ActiveChecksDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports